import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class HeaderExtension extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        // {/* 智库频道-关于我们-二级导航延伸 */}

        return (
            <div className={styles.menu_100}>
                <div className={styles.menu_1000}>
                    <ul>
                        <li>
                            <a href="http://pit.ifeng.com/listpage/71011/1/list.shtml" target="_blank" title="">
                                智库动态
                            </a>
                        </li>
                        <li>
                            <a href="http://pit.ifeng.com/aboutUs/index.shtml" target="_blank" title="">
                                智库简介
                            </a>
                        </li>
                        <li>
                            <a href="http://pit.ifeng.com/aboutUs/gaoduanzhiku/index.shtml" target="_blank" title="">
                                高端智库
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(HeaderExtension);
